import { render, staticRenderFns } from "./ManageCommittee.vue?vue&type=template&id=1c235a7e&"
import script from "./ManageCommittee.vue?vue&type=script&lang=js&"
export * from "./ManageCommittee.vue?vue&type=script&lang=js&"
import style0 from "./ManageCommittee.vue?vue&type=style&index=0&lang=scss&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports